import React, {useState} from 'react';


import * as tableConstants from './tableConstants';
import * as styleUtils from '../../../utils/styleUtils';

import {I18nMessage} from '../../contexts/I18n';
import {Icon, iconConstants} from '../Icon';
import {listConstants} from '../../contexts/List';

import styles from './Table.scss';


const getCellClass = ({center, width}, ...additionalClassName) => {

    return styleUtils.toClasses(
        'col',
        width ? `col-${width}` : null,
        center ? styles.center : null,
        ...additionalClassName
    );
};


const getSetSortBy = (sortBy, sortByProperty) => sortBy.find(({property}) => property === sortByProperty) || {};


function Table({columns, data, onSort, sortDefault}) {

    /** @var sortBy {array|object[]} */
    const [sortBy, setSortBy] = useState(sortDefault);

    const onSortClick = requestedSortProperty => {

        // reset sorting if no flip of property or dir
        let dir = null;
        let property = null;

        // get current sort-by, if set
        const currentSortBy = getSetSortBy(sortBy, requestedSortProperty) || {};

        // no current sorting OR switch to different sort property
        if (currentSortBy.property === null || currentSortBy.property !== requestedSortProperty) {

            dir = listConstants.SORT_DIR_ASC;
            property = requestedSortProperty;

        // or currently sorted property is clicked again
        } else if (currentSortBy.property === requestedSortProperty && currentSortBy.dir === listConstants.SORT_DIR_ASC) {

            dir = listConstants.SORT_DIR_DESC;
            property = requestedSortProperty;
        }

        const newSortData = {
            dir,
            property
        };

        // remove any existing sorting
        const newSortBy = sortBy.filter(({property}) => property !== requestedSortProperty);

        // and add as first sortable property only if set
        if (property) {
            newSortBy.unshift(newSortData);
        }

        setSortBy(newSortBy);
        onSort(newSortBy);
    };

    return (
        <div className={styleUtils.toClasses(styles.table, 'container')}>

            <div className={styles.tableHeaderInfo}>
                <Icon icon={iconConstants.ICON_INFO_CIRCLE}/>
                <I18nMessage id={'table.data.info.sort.by.columns'}/>
            </div>

            <div className={styleUtils.toClasses(styles.header, 'row')}>
                {columns.map(column => {

                    const {header, id} = column;
                    const sortByProperty = column.sortBy;

                    // check if column is contained in sorting
                    const setSortBy = sortBy.find(({property}) => property === sortByProperty) || {};
                    const setSortByPosition = sortBy.findIndex(({property}) => property === sortByProperty);

                    return (
                        <div
                            className={getCellClass(column, styles.headerCell, sortByProperty ? styles.sortable : null)}
                            key={`table-header-${id}`}
                            onClick={event => {
                                event.preventDefault();
                                if (sortByProperty) {
                                    onSortClick(sortByProperty);
                                }
                            }}
                        >

                            {!sortByProperty && (typeof header === 'function' ? header(column) : header)}

                            {sortByProperty && (
                                <>
                                    <span
                                        className={styles.columnText}
                                        title={sortByProperty && (`sort by ${sortByProperty}`)}
                                    >
                                        {typeof header === 'function' ? header(column) : header}
                                    </span>
                                    <a
                                        className={sortByProperty === setSortBy.property ? styles.sorted : null}
                                        title={`sort by ${sortByProperty}`}
                                    >
                                        <span className={styles.sortingIndicator}>{setSortByPosition !== -1 ? setSortByPosition + 1 : null}</span>
                                        <Icon
                                            icon={
                                                sortByProperty === setSortBy.property && setSortBy.dir === listConstants.SORT_DIR_ASC
                                                    ? iconConstants.ICON_TRIANGLE_TOP
                                                    : iconConstants.ICON_TRIANGLE_BOTTOM
                                            }
                                        />
                                    </a>
                                </>
                            )}

                        </div>
                    );
                })}
            </div>

            <div className={styleUtils.toClasses(styles.tableBody)}>

                {data.map((row, rowIndex) => {

                    return (
                        <div
                            className={'row'}
                            key={`table-row-${rowIndex}`}
                        >

                            {columns.map((column, columnIndex) => {

                                const {header, cell} = column;

                                return (
                                    <div
                                        className={getCellClass(column)}
                                        key={`table-row-${rowIndex}-column-${columnIndex}`}
                                    >
                                        <span className={styles.columnLabel}>
                                            {typeof header === 'function' ? header(column) : header}
                                            :
                                        </span>
                                        <span className={styles.cellData}>
                                            {cell(row)}
                                        </span>
                                    </div>
                                );
                            })}

                        </div>
                    );
                })}

            </div>

        </div>
    );
}


Table.propTypes = {
    ...tableConstants.SHAPE_TABLE
};

Table.defaultProps = {
    sortDefault: []
};


export default Table;
